<template>
  <div class="home">
    <h2>Wybierz kasę wirtualną:</h2>
    <div class="kasy">
      <router-link :to="{name: 'sdf', params: {id: 'sdf1'}}" class="linki"><img src="../assets/sdf12.png" alt="sdf1" id="sdf-1"/></router-link>
      <router-link :to="{name: 'sdf', params: {id: 'sdf3'}}" class="linki"><img src="../assets/sdf3.png" alt="sdf3" id="sdf-3"/></router-link>
    </div>
  </div>
</template>

<script>

import { onMounted } from 'vue';
export default {
  name: 'HomeView',
  
  setup(){
    onMounted(()=>{
        document.querySelector('body').style.overflow = 'scroll'
      })
  }
}
</script>
<style>
  .home h2{
    margin-bottom: 3em;
  }
  .kasy{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .kasy .linki{
    transition: 0.3s ease-in-out;
  }
  .kasy .linki:hover{
    transform: scale(1.1);
  }
  

</style>
